import React from 'react';
import { Handle, Position } from 'reactflow';
import { NodeData } from '../../../pages/campaings/flows/types';

interface Props {
  data: NodeData;
}
const HttpBody: React.FC<Props> = ({ data }) => {
  if (!data.http) return <div>No se encontró información</div>;
  return (
    <div className="mt-2">
      <h6 className="node-title2 my-0 fs-8">URL DEV</h6>
      <p className="nowrap-lines-1 mb-3">{data.http.url_dev}</p>
      <h6 className="node-title2 mb-0 fs-8">URL PRODUCCIÓN</h6>
      <p className="nowrap-lines-1 mb-3">{data.http.url_prod}</p>

      <h6 className="mb-1 mt-3 fs-8">Respuestas</h6>
      <ul className="chatbot-node-outputs">
        {data.http.responses.map((r, i) => (
          <li key={i} className="nowrap-lines-1 position-relative">
            <span>{r}</span>
            <Handle
              type="source"
              position={Position.Right}
              id={r}
              className="handle-connector internal"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(HttpBody);
